var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('x-data-table',{staticClass:"data-table_type_consumption-analysis",attrs:{"headers":_vm.preparedHeaders,"items":_vm.preparedConsumptionList,"item-class":"data-table__text_cursor_default"}})}
var staticRenderFns = []

export { render, staticRenderFns }